module.exports = __webpack_public_path__ + "1c9ed6f2a6e6ac4ac0fcba7f0ea227c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/4_column_xlarge_x1_variable/public/news/img3_0.jpg
// module id = 478
// module chunks = 0